import { Space } from "antd";
import clsx from "clsx";
import { GradientButton } from "components/GradientButton";
import { routesEnum } from "pages/Routes";
import React, { FC } from "react";
import { Link } from "react-router-dom";
import styles from "./BannerCenter.module.css";
import Decor from "./Decor";

const BannerCenter: FC = () => {
  return (
    <div className={styles.root}>
      <div className="center">
        <Space align="center">
          <img src="/images/landing_v2/puzzle.png" />
          <h1 className={clsx(styles.h1, styles.build)}>Buidl,&nbsp;</h1>
        </Space>
        <Space align="center">
          <img src="/images/landing_v2/chat-bubble.png" />
          <h1 className={clsx(styles.h1, styles.network)}>Network</h1>
          <h1 className={styles.h1}>&nbsp;&&nbsp;</h1>
        </Space>
        <Space align="center">
          <img src="/images/landing_v2/rocket.png" />
          <h1 className={clsx(styles.h1, styles.earn)}>Earn</h1>
        </Space>
      </div>
      <div className="center">
        <h1 className={styles.h1}>
          With <b>CrowdHack</b>
        </h1>
      </div>
      <h4 className={styles.h4}>
        A decentralized hackathon platform where you{" "}
        <span className={styles.purple}>build cool stuff,</span>{" "}
        <span className={styles.green}>
          support the open source ecosystem,{" "}
        </span>
        <span className={styles.orange}> earn rewards,</span> and{" "}
        <span className={styles.lightGreen}>get sweet prizes.</span>
      </h4>

      <div className="center">
        <Link to={routesEnum.home}>
          <GradientButton size="large">Join The Community</GradientButton>
        </Link>
      </div>

      <Decor />
    </div>
  );
};

export default BannerCenter;
